import { useCallback, useState } from 'react';

import { useSetProductItemSalePriceMutation } from '@app/api/Warehouses';
import type { EditProductItemSalePriceModalProps } from '@app/components/Modals/EditProductItemSalePriceModal/ui/EditProductItemSalePriceModal.main';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';

interface UseEditProductItemSalePriceModalReturn {
  salePrice: number | null;
  setSalePrice(value: number | null): void;
  isSaving: boolean;
  saveHandler(): Promise<void>;
  canSubmit: boolean;
}

export const useEditProductItemSalePriceModal = ({
  productItemId,
  currentSalePrice,
  onClose,
  afterSave,
}: EditProductItemSalePriceModalProps): UseEditProductItemSalePriceModalReturn => {
  const {
    params: { ActiveBranchId },
  } = useUserPrint();
  const { showNotification } = useNotification();

  const [salePrice, setSalePrice] = useState<number | null>(
    currentSalePrice ?? null
  );

  const [setProductItemSalePrice, { isLoading: isSaving }] =
    useSetProductItemSalePriceMutation();

  const canSubmit = !isSaving;

  const saveHandler = useCallback(async () => {
    if (salePrice === null || salePrice < 0) return;

    try {
      await setProductItemSalePrice({
        ActiveBranchId,
        ProductItemId: productItemId,
        SalePrice: salePrice,
      }).unwrap();
      showNotification('Цена продажи обновлена', 'success');
      afterSave?.();
      onClose();
    } catch (error) {
      showNotification(error);
    }
  }, [
    ActiveBranchId,
    productItemId,
    salePrice,
    setProductItemSalePrice,
    showNotification,
    afterSave,
    onClose,
  ]);

  return {
    salePrice,
    setSalePrice,
    isSaving,
    saveHandler,
    canSubmit,
  };
};
